import { TrackFlightLog } from '../../../../types/Track';
import { PointOfInterest } from '../../../../common/api/spidertracks-sdk/types/PointOfInterest';

export const findFlightlogsEventPoiByEventId = (
  eventId: string,
  trackFlightlog: TrackFlightLog
): PointOfInterest | undefined => {
  const events = Object.values(trackFlightlog).filter(
    property => typeof property === 'object' && property !== null
  );
  const poi = events.find(event => event?.eventId === eventId)?.location;
  if (!poi) return undefined;

  return {
    // ToDo: add Source and Distance to flightlog event location
    // ToDo: review this once flightlog event location is updated
    source: 'reference',
    name: poi.name ?? undefined,
    latitude: poi.latitude ?? undefined,
    longitude: poi.longitude ?? undefined,
    ICAO: poi.ICAO ?? undefined,
    IATA: poi.IATA ?? undefined,
    other: poi.other ?? undefined,
    locationId: poi.locationId,
    locationTypeId: poi.locationTypeId ?? 0,
    distance: 0
  };
};
